import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "submit-apply common-el-wrap" }
const _hoisted_2 = { class: "submit-apply-bd" }
const _hoisted_3 = { class: "t-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "submit-apply-bd--tips" }, "大赛需实名参加，请填写与腾讯云实名认证一致的信息，虚假信息会导致报名审核不通过，比赛结果作废", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserInfo = _resolveComponent("UserInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_UserInfo, {
          userStatus: _ctx.store.state.userStatus,
          realInfo: _ctx.realInfo
        }, null, 8, ["userStatus", "realInfo"])
      ])
    ])
  ]))
}